<svg class="spinner">
  <use xlink:href="#spinner" />
</svg>
